<template>
    <div>
        <a-form-item :label="$t('modules.standartModule')">
            <a-select v-model="localValue.module">
                <a-select-option value="contact">{{ $t('modules.contact') }}</a-select-option>
                <a-select-option value="ticket">{{ $t('modules.moduleTicket') }}</a-select-option>
                <a-select-option value="task">{{ $t('modules.moduleTask') }}</a-select-option>
                <a-select-option value="calendar">{{ $t('modules.moduleCalendar') }}</a-select-option>
                <a-select-option value="email">{{ $t('modules.moduleEmail') }}</a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item :label="$t('modules.connectionType')">
            <a-select v-model="localValue.connectionType" @change="handleConnectionTypeChange">
                <a-select-option value="field">{{ $t('modules.connField') }}</a-select-option>
                <a-select-option 
                    v-if="localValue.module === 'contact'" 
                    value="customProperties"
                >
                    {{ $t('modules.connCustomProperties') }}
                </a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item v-if="localValue.connectionType === 'field'" :label="$t('modules.connField')">
            <a-select v-model="localValue.field">
                <a-select-option value="_id">{{ $t('modules.connRecordId') }}</a-select-option>
                <template v-if="localValue.module === 'contact'">
                    <a-select-option value="name">{{ $t('modules.connName') }}</a-select-option>
                    <a-select-option value="email">{{ $t('modules.connEmail') }}</a-select-option>
                    <a-select-option value="phone">{{ $t('modules.connPhone') }}</a-select-option>
                    <a-select-option value="whatsappNumber">{{ $t('modules.connWhatsappNumber') }}</a-select-option>
                </template>
            </a-select>
        </a-form-item>

        <a-form-item 
            v-if="localValue.connectionType === 'customProperties'" 
            :label="$t('modules.connCustomProperty')"
        >
            <a-select v-model="localValue.field">
                <a-select-option 
                    v-for="prop in contactProperties" 
                    :key="prop._id" 
                    :value="prop._id"
                >
                    {{ prop.label }}
                </a-select-option>
            </a-select>
        </a-form-item>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        },
        contactProperties: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            localValue: this.value
        }
    },
    methods: {
        handleConnectionTypeChange() {
            this.localValue.field = null;
            this.$emit('input', this.localValue);
        }
    },
    watch: {
        value: {
            deep: true,
            handler(newVal) {
                this.localValue = newVal;
            }
        },
        localValue: {
            deep: true,
            handler(newVal) {
                this.$emit('input', newVal);
            }
        }
    }
}
</script>
